import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../..";

const getFiltersFieldsSelector = createSelector(
  (state: RootState) => state.filtersSelectorState,
  (state) => state.filtersFields,
);

const getActiveFiltersSelector = createSelector(
  (state: RootState) => state.filtersSelectorState,
  (state) => state.activeFilters,
);

const getIsLoadingFiltersSelector = createSelector(
  (state: RootState) => state.filtersSelectorState,
  (state) => state.isLoadingFilters,
);

const getIsFiltersModalOpenSelector = createSelector(
  (state: RootState) => state.filtersSelectorState,
  (state) => state.isFiltersModalOpen,
);

const getIsFiltersDrawerOpenSelector = createSelector(
  (state: RootState) => state.filtersSelectorState,
  (state) => state.isFiltersDrawerOpen,
);

export const filtersStateSelectors = {
  filtersFields: getFiltersFieldsSelector,
  isLoadingFilters: getIsLoadingFiltersSelector,
  activeFilters: getActiveFiltersSelector,
  isFiltersModalOpen: getIsFiltersModalOpenSelector,
  isFiltersDrawerOpen: getIsFiltersDrawerOpenSelector,
};
